
<template>
    <BModal :model-value="modal" scrollable centered @update:modelValue="updateModal" >
        <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Destination</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="$emit('updateModal', false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BForm>
            <BContainer>
                
                <BRow>
                    <BCol>
                        <BFormInput type="text" id="input-1" v-model="optionDefault" placeholder="Code"  class="form-group" />
                    </BCol>
                    <BCol>
                        <BFormInput type="text" id="input-1" v-model="contact" :state="state" placeholder="Name" class="form-group" />
                    </BCol>
                </BRow>
                <BRow >
                    
                </BRow>
                
                
                
            </BContainer>
            
                
        
        </BForm>
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary"  class="mr-2">Save</BButton>
                <BButton variant="danger" @click="$emit('updateModal', false)">Cancel</BButton>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal,BRow, BCol, BForm, BFormInput, BButton } from 'bootstrap-vue-next';


export default{
    name : 'DestinationForm',
    components : { BModal,BRow, BCol, BForm, BFormInput, BButton },
    props : {
        action : String,
        modal : Boolean
    },
    setup(props, {emit}){
        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        };
        return {
            updateModal
        }
    }
}
</script>


